import React from "react";
import { Tooltip } from "@mantine/core";

const Legends = ({ role }) => {
  const deskStatusAdmin = [
    {
      status: "Occupied",
      color: "red",
      desc: "Desk is currently being used.",
    },
    {
      status: "Available",
      color: "green",
      desc: "Desk is free and can be used immediately.",
    },
    {
      status: "Occupied Away ",
      color: "orange",
      desc: "Assigned desk temporarily not in use; user expected to return.",
    },
    {
      status: "Blocked",
      color: "blue",
      desc: "Desk not available for use due to various operational reasons.",
    },
    {
      status: "Under Maintenance",
      color: "black",
      desc: "Desk out of service for maintenance; not available for booking.",
    },
    {
      status: "Unattached Sensor",
      color: "pink",
      desc: "Sensor at the desk is not connected to the system; requires attention",
    },
  ];

  const deskStatusBasic = [
    { status: "Occupied", color: "red", desc: "Desk is currently being used." },
    {
      status: "Available",
      color: "green",
      desc: "Desk is free and can be used immediately.",
    },
    {
      status: "Occupied Away ",
      color: "orange",
      desc: "Assigned desk temporarily not in use; user expected to return.",
    },
    {
      status: "Blocked",
      color: "blue",
      desc: "Desk not available for use due to various operational reasons.",
    },
  ];

  return (
    <div className="flex gap-4 items-center mt-2  mb-8 flex-wrap">
      {role === "basic"
        ? deskStatusBasic.map((desk) => {
            return (
              <div
                className="flex gap-2 items-center px-2 py-1   border border-solid rounded-xl border-grayText4 hover:bg-lightGray"
                key={desk.status}
              >
                <div
                  className="w-3 h-3 rounded-[50%] "
                  style={{ background: desk.color }}
                />
                <Tooltip
                  label={<p className="w-44 text-wrap">{desk.desc}</p>}
                  withArrow
                >
                  <p className="text-sm">{desk.status}</p>
                </Tooltip>
              </div>
            );
          })
        : deskStatusAdmin.map((desk) => {
            return (
              <div
                className="flex gap-2 items-center px-2 py-1   border border-solid rounded-xl border-grayText4 hover:bg-lightGray"
                key={desk.status}
              >
                <div
                  className="w-3 h-3 rounded-[50%] "
                  style={{ background: desk.color }}
                />
                <Tooltip
                  label={<p className="w-44 text-wrap">{desk.desc}</p>}
                  withArrow
                >
                  <p className="text-sm">{desk.status}</p>
                </Tooltip>
              </div>
            );
          })}
    </div>
  );
};

export default Legends;
